import { render, staticRenderFns } from "./openAllocated.vue?vue&type=template&id=3a39abba&"
import script from "./openAllocated.vue?vue&type=script&lang=js&"
export * from "./openAllocated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports